module.exports = __webpack_public_path__ + "img/A4扫描仪.7bd6735d.jpg";